module.exports = __webpack_public_path__ + "media/images/icons/outlined/fund-7bbefed60fe359675763bfd9c24ebf31.svg";